import BadRequestHttpError from "../BadRequestHttpError";
import INotFoundHttpErrorResponse from "../../interfaces/BadRequest/INotFoundHttpErrorResponse";

export default class NotFoundHttpError extends BadRequestHttpError<INotFoundHttpErrorResponse> {
    constructor(response: INotFoundHttpErrorResponse) {
        super("Not found!", response);
    }
}
